export default __webpack_public_path__ + "static/bg-61559a61c791fa54f900afdfbe7b1c5f.png";